<template>
    <div class="submain">
        <div class="content flexbox">
            <el-card class="box-card usermsg">
                <div class="flexbox basemsg">
                    <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
                    <div class="msg">
                        <p>{{userInfo.c_Boss}} <span>{{userInfo.c_Post}}</span></p>
                        <span>{{userInfo.MOBILE}}</span>
                    </div>
                </div>
                <div class="uinfo">
                    <div class="cell">
                        <span>客户编码：<i></i></span>
                        <p>{{userInfo.customerCode}}</p>
                    </div>
                    <div class="cell">
                        <span>客户名称：<i></i></span>
                        <p>{{userInfo.customerName}}</p>
                    </div>
                    <div class="cell">
                        <span>建档日期：<i></i></span>
                        <p>{{userInfo.c_CreatedDate}}</p>
                    </div>
                    <div class="cell">
                        <span>地址：<i></i></span>
                        <p>{{userInfo.c_Address}}</p>
                    </div>
                    <div class="cell">
                        <span>法人：<i></i></span>
                        <p>{{userInfo.c_LegalPerson}}</p>
                    </div>
                    <div class="cell">
                        <span>税号：<i></i></span>
                        <p>{{userInfo.c_SH}}</p>
                    </div>
                    <!-- <div class="cell">
                        <span>合作年限：<i></i></span>
                        <p>{{userInfo.c_HZNX}}</p>
                    </div> -->
                    <div class="cell">
                        <span>客户等级：<i></i></span>
                        <p>{{userInfo.c_Level}}</p>
                    </div>
                    <div class="cell">
                        <span>信用等级：<i></i></span>
                        <p>{{userInfo.c_CreditLevel}}</p>
                    </div>
                    <div class="cell">
                        <span>营业执照：<i></i></span>
                        <p>{{userInfo.c_BL}}</p>
                    </div>
                </div>
                <img class="bgimg" src="../../../assets/img/userinfopic.png">
            </el-card>
            <div class="userdata">
                <div class="top">
                    <h2>财务</h2>
                    <div class="flexbox con">
                        <div class="chartbox">
                            <el-progress type="circle" :percentage="percentdata" color="rgb(244 ,36, 52)">
                                <template #default="{ percentage }">
                                    <p class="percentage-label">已用额度</p>
                                    <span class="percentage-value">{{ percentdata }}%</span>
                                  </template>
                            </el-progress>
                        </div>
                        <div class="flexbox chartmsg">
                            <div class="box">
                                <div class="flexbox cell">
                                    <div class="ico"><i class="el-icon-wallet"></i></div>
                                    <div class="content">
                                        <span>总信用额度</span>
                                        <p>{{ userData.TCF_TOTALCREDIT }}元</p>
                                    </div>
                                </div>
                                <div class="flexbox cell">
                                    <div class="ico"><i class="el-icon-warning-outline"></i></div>
                                    <div class="content">
                                        <span>超期欠款</span>
                                        <p>{{ userData.TCF_OVERDUEDEBT }}元</p>
                                    </div>
                                </div>
                                <div class="flexbox cell">
                                    <div class="ico"><i class="el-icon-time"></i></div>
                                    <div class="content">
                                        <span>超期天数</span>
                                        <p>{{ userData.TCF_OVERDAY }}天</p>
                                    </div>
                                </div>
                                <div class="flexbox cell">
                                    <div class="ico"><i class="el-icon-money"></i></div>
                                    <div class="content">
                                        <span>罚息额</span>
                                        <p>{{ userData.TCF_PENALTYINTEREST }}元</p>
                                    </div>
                                </div>
                            </div>
                            <div class="box flexboxcol">
                                <div class="flexbox cell">
                                    <div class="content">
                                        <span>已用额度</span>
                                        <p>{{ userData.TCF_USECREDIT }}元</p>
                                    </div>
                                </div>
                                <div class="cell">
                                    <div class="flexbox ctop">
                                        <span>单号</span>
                                        <span>金额</span>
                                        <span>账期剩余天数</span>
                                    </div>
                                    <div class="ccon">
                                        <div class="flexbox ccell" v-for="(item, index) in userData.SPFT">
                                            <p>{{ item.TCFD_CODE }}</p>
                                            <p>{{ item.TCFD_MONEY }}元</p>
                                            <p>{{ item.TCFD_RESIDUE }}天</p>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mid">
                    <h2>客诉
                        <router-link :to="{name: 'MyQuestion'}" class="redw">更多 ></router-link>
                    </h2>
                    <div class="con">
                        <el-table
                            :data="qutabledata"
                            stripe
                            border
                            style="width: 100%">
                            <el-table-column
                            type="index"
                            label="序号"
                            width="50">
                            </el-table-column>
                            <el-table-column
                            prop="TP_CODE"
                            label="问题编号"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="STATUS"
                            label="状态"
                            width="90">
                            </el-table-column>
                            <el-table-column
                            prop="TP_THEME"
                            label="主题"
                            width="180">
                            </el-table-column>
                            <el-table-column
                            prop="TP_CUSTOMER"
                            label="客户简称"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="TP_CUSTOMER_CODE"
                            label="客户编码"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="PROPOSER"
                            label="申请人"
                            width="90">
                            </el-table-column>
                            <el-table-column
                            prop="LO_NAME"
                            label="申请人部门"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="CTTIME"
                            label="申请时间"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="BPROBLEM"
                            label="问题大类"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="LPROBLEM"
                            label="问题小类"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="PRINCIPAL"
                            label="主责人"
                            width="90">
                            </el-table-column>
                            <!-- <el-table-column
                            prop="address"
                            label="主责人科室">
                            </el-table-column>
                            <el-table-column
                            prop="address"
                            label="主责人部门">
                            </el-table-column> -->
                        </el-table>
                    </div>
                </div>
                <div class="bot">
                    <h2>返还</h2>
                    <div class="flexbox con">
                        <div class="flexbox cell">
                            <div class="ico"><i class="el-icon-money"></i></div>
                            <div class="content">
                                <span>应发放</span>
                                <p>{{ userData.TCR_SHOULDMADE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <div class="ico"><i class="el-icon-money"></i></div>
                            <div class="content">
                                <span>实际发放</span>
                                <p>{{ userData.TCR_ACTUALMADE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <div class="ico"><i class="el-icon-money"></i></div>
                            <div class="content">
                                <span>剩余发放</span>
                                <p>{{ userData.TCR_RESIDUALMADE }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router'
    import { ElMessage } from 'element-plus'
    import config from '@/api/config.js' 

    export default {
        name: 'PersonalCenter',
        components: {
            
        },
        setup() {
            let { proxy } = getCurrentInstance()
            let router = useRouter()
            let pageData = reactive({
                userId: '',
                userInfo: '',
                userData: '',
                percentdata: 0,
                qutabledata: []
            })
            // 获取用户基本信息
            let getUserInfo = () => {
                let datauser = {
                    postType: 'queryInfo',
                    customerId: JSON.parse(localStorage.getItem('userInfo')).customerCode,
                }
                proxy.$axios.postReq('/meide/REST/QueryUserIdInfo', datauser)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.userInfo = res.data
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 获取左侧资料
            let getUserData = () => {
                let datauser = {
                    postType: 'Search'
                }
                proxy.$axios.postReq('/meide/REST/CustomerPortarit', datauser)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.userData = res.items.data[0]
                        pageData.percentdata = res.items.data.length != 0? parseFloat(res.items.data[0].TOTALCREDIT): ''
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 获取问题-投诉
            let getProblems = () => {
                let data = {
                    postType: 'Search',	
                    source: 'customer',
                    type: 'TS', // 问题类型(投诉 TS，咨询 ZX)	
                    PageStart: '1', // 页数	
                    PageLimit: '20', // 条数	
                    stage: 'XQ', //阶段:FF 分发  CL 处理 XQ:详情
                    STARTTIME: '', // 申请开始时间	
                    ENDTIME: '', // 申请结束时间	
                    REPLYSTARTTIME: '', // 答复开始时间	
                    REPLYENDTIME: '', // 答复结束时间	
                    PROBLEMCODE: '', // 问题编码	
                    PRINCIPAL: '', // 主责人	
                    STATUS: '', // 状态
                    CUSTOMER: '', // 客户简称	
                    KEYWORD: '', // 关键字
                }
                proxy.$axios.postReq('/meide/REST/ProblemClose', data)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.qutabledata = res.items
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    proxy.$alert(error, '提示', {
                        confirmButtonText: '确定',
                        callback: action => {}
                    })
                })
            }
            onBeforeMount(() => {
                getUserInfo()
                getUserData()
                getProblems()
            })


            return {
                ...toRefs(pageData),
                getUserInfo,
                getUserData,
                getProblems
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {}
    .content {
        align-items: flex-start;
        justify-content: space-between;
        ::v-deep(.el-card) {
            overflow: visible;
        }
        .usermsg {
            width: 358px;
            position: relative;
            padding-bottom: 20px;
            .basemsg {
                ::v-deep(.el-avatar) {
                    width: 90px;
                    height: 90px;
                }
                .msg {
                    margin-left: 20px;
                    p {
                        margin-bottom: 6px;
                    }
                    span {
                        font-size: 12px;
                    }
                }
            }
            .uinfo {
                .cell {
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    span {
                        display: block;
                        width: 70px;
                        text-align: justify;
                        font-size: 12px;
                        font-weight: bold;
                        
                        /* i {
                            display: inline-block;
                            width: 100%;
                        } */
                    }
                    p {
                        font-size: 12px;
                        margin-left: 6px;
                    }
                }
            }
            .bgimg {
                position: absolute;
                z-index: 9;
                bottom: -30px;
                left: 0;
                width: 358px;
            }
        }
        .userdata {
            width: 820px;
            background: #fff;;
            h2 {
                padding: 15px 20px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #ccc;
                a {
                    float: right;
                }
            }
            .con {
                padding: 20px 15px;
                border-bottom: 1px solid #ccc;
            }
            .top {
                .con {
                    padding: 20px 35px;
                   .chartbox {
                       margin-right: 60px;
                       p {
                           margin-bottom: 10px;
                           font-size: 12px;
                       }
                   }
                   .chartmsg {
                       .box {
                           margin-right: 40px;
                           height: 212px;
                           .cell {
                               margin-bottom: 8px;
                                .ico {
                                    width: 40px;
                                    height: 40px;
                                    line-height: 45px;
                                    text-align: center;
                                    background: rgb(244 ,36, 52);
                                    border-radius: 200px;
                                    i {
                                        color: #fff;
                                        font-size: 20px;
                                    }
                                }
                                .content {
                                    margin-left: 15px;
                                }
                                span {
                                    font-weight: bold;
                                    font-size: 12px;
                                }
                                p {
                                    font-size: 12px;
                                    margin-top: 10px;
                                }
                                .ctop span {
                                    display: block;
                                    width: 120px;
                                }
                                .ccon p {
                                    width: 120px;
                                }
                           }
                       }
                       .flexboxcol {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                        }
                        .flexboxend {
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-end;
                        }
                   }
                }
            }
            .mid {
                .con {}
            }
            .bot {
                .con {
                    justify-content: space-around;
                    border-bottom: none;
                    .cell {
                        .ico {
                            width: 50px;
                            height: 50px;
                            line-height: 60px;
                            text-align: center;
                            background: rgb(244 ,36, 52);
                            border-radius: 200px;
                            i {
                                color: #fff;
                                font-size: 26px;
                            }
                        }
                        .content {
                            margin-left: 15px;
                            span {
                                color: #999;
                            }
                            p {
                                font-size: 18px;
                                font-weight: bold;
                                margin-top: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>